import { useMfaLabels } from 'client/util/Constants/MfaLabels';

/**
 * Values match `SmsOtpSendResponse.status` JSON from user-console
 * (`resp.Status.String()` → e.g. PENDING, ATTEMPTS_EXCEEDED).
 * @see jumpcloud.auth.SmsOtpSendResponse.SmsOtpSendStatus
 */
export const OtpStatus = {
  UNSPECIFIED: 'UNSPECIFIED',
  PENDING: 'PENDING',
  EXPIRED: 'EXPIRED',
  FAILED: 'FAILED',
  ATTEMPTS_EXCEEDED: 'ATTEMPTS_EXCEEDED',
} as const;

export function getOtpErrorMessage(status: string): string {
  const mfaLabels = useMfaLabels();

  switch (status) {
    case OtpStatus.UNSPECIFIED:
      return mfaLabels.sms_otp.error.unknown;
    case OtpStatus.PENDING:
      return mfaLabels.sms_otp.error.pending;
    case OtpStatus.EXPIRED:
      return mfaLabels.sms_otp.error.expired;
    case OtpStatus.FAILED:
      return mfaLabels.sms_otp.error.failed;
    case OtpStatus.ATTEMPTS_EXCEEDED:
      return mfaLabels.sms_otp.error.maxAttempts;
    default:
      return mfaLabels.sms_otp.error.unknown;
  }
}
